export default {
  state: {
    academyData: {}
  },

  getters: {
    getAcademyData (state) {
      return state.academyData
    }
  },

  mutations: {
    setAcademyData (state, academyData) {
      state.academyData = academyData
    },

    unsetAcademyData (state) {
      state.academyData = {}
    }
  }
}
